export const WHATSAPP_NUMBER = '917012991652';

export const PRICING = {
  platforms: {
    static: { label: 'Standard website', price: 7999, market: 30000 },
    wp: { label: 'WordPress website', price: 12999, market: 50000 },
  },
  domain: 999,
  hosting: 3999,
  basePages: 7,
  maxExtraPages: 10,
  perPage: 500,
  perPageMarket: 5000,
};

export const OFFER = { wpFree: true, endsAt: '2026-10-31T23:59:59+05:30', windowMs: (60 + 14) * 60 * 1000, storageKey: 'gd_wp_offer_start' };

export const BASE_PAGE_NAMES = [
  'Home',
  'About',
  'Services',
  'Gallery',
  'Testimonials',
  'FAQ',
  'Contact',
];

export const PAGE_OPTIONS = [
  ...BASE_PAGE_NAMES,
  'Our Team',
  'Portfolio / Projects',
  'Pricing',
  'Careers',
  'Locations',
  'Offers',
  'Privacy Policy',
  'Terms & Conditions'
];

export const INCLUDED = [
  '7 pages',
  'Logo',
  'All page content',
  'Domain + hosting, 1 year',
  'Works on every phone',
  'Contact form + WhatsApp',
  'Google-ready SEO basics',
  '2 rounds of changes',
];

export const PLATFORMS = [
  {
    id: 'static',
    title: 'Standard',
    desc: 'Fast and secure. We make changes for you.',
    info: "No plugins to break or hack, the fastest load times, and we make every change for you.",
    delta: 0,
    market: 30000,
  },
  {
    id: 'wp',
    title: 'WordPress',
    desc: 'Edit anything yourself, anytime.',
    info: "Log in and edit text, photos and posts yourself, any time, without waiting on anyone.",
    delta: 5000,
    market: 20000,
  },
];

export const ADDONS = [
  { id: 'booking', title: 'Meeting booking', desc: 'Customers book meetings with you through a Cal.com calendar on your site.', info: "Customers pick a free slot and it lands straight in your calendar, no back-and-forth calls.", price: 1500, market: 15500, sub: 'Cal.com' },
  { id: 'email', title: 'Business email', desc: 'Zoho Mail (free plan) set up on your own domain. You pay only for the setup.', info: "you@yourbusiness.com looks far more trustworthy to customers than a Gmail address.", price: 2000, market: 10500, sub: 'Zoho Mail setup', tag: 'Recommended' },
  { id: 'gbp', title: 'Google Business Profile', desc: 'Your profile set up and optimised for Maps and Search. Verification is completed by you.', info: "Most local customers find businesses on Google Maps first, and a complete profile gets you seen there.", price: 2500, market: 21000, sub: 'Setup, you verify' },
  { id: 'blog', title: 'Blog setup', desc: 'A blog section set up and ready for your articles.', info: "Regular articles help you show up for more searches and answer customer questions before they call.", price: 1500, market: 13000, sub: 'Setup', notWithWp: true },
  { id: 'brandseo', title: 'Brand keyword SEO', desc: 'Show up first when customers search your business name on Google. Within 1 month.', info: "When customers Google your name, they should find you first, not a directory or a competitor.", price: 4999, market: 14999, sub: 'Within 1 month', tag: 'Recommended' },
  { id: 'social', title: 'Social media setup', desc: 'Facebook, Instagram, LinkedIn, X (Twitter) and Pinterest, each with a proper profile picture, cover image and complete business details.', info: "Complete, matching profiles make your business look established when customers check you out.", price: 3999, market: 11999, sub: '5 platforms' },
];

export const STEPS = [
  { hour: 'Hour 0', title: 'Send your inputs', desc: 'Business details, services and photos. WhatsApp is fine.' },
  { hour: 'Hour 12', title: 'We build', desc: 'Logo, content and pages. No calls, no meetings.' },
  { hour: 'Hour 24', title: "It's live", desc: 'On your own domain. Share it with customers.' },
];

export const FAQS = [
  { q: 'What if my inputs are not ready?', a: 'The clock starts when we have your business details, services, photos and logo brief. If inputs arrive in parts, delivery takes longer.' },
  { q: 'Do I own the website?', a: 'Yes. Once delivered, the design, files and domain are yours. On WordPress you also get full admin access.' },
  { q: 'Standard or WordPress?', a: 'Standard if you want a fast, secure site and are happy to ask us for changes. WordPress if you want to log in and edit pages or add posts yourself.' },
  { q: 'Is domain and hosting really included?', a: 'Yes, for the first year on both plans. From year two, renewals are ₹999/year for the domain and ₹3,999/year for cloud hosting. Already have a domain? We can use it.' },
  { q: 'Can I add things later?', a: 'Yes. Every add-on can be added after launch at the same price.' },
  { q: 'How do I pay?', a: 'In full before work begins. We share payment details on WhatsApp once your build is confirmed.' },
];

export const TERMS = [
  { t: '1. Scope', b: 'The base package (Standard at ₹7,999 or WordPress at ₹12,999; as a limited promotion running until 31 October 2026, the WordPress upgrade is free for orders sent on WhatsApp within 1 hour 14 minutes of a visitor\'s first visit to this page, as shown by the on-page timer and the deadline included in the order message; payment may follow after the deadline) covers design and development of one website with up to 7 pages, a logo, page content written from inputs supplied by the client, and domain plus hosting for one year. Additional pages, features and services are only included when selected and paid for as add-ons.' },
  { t: '2. Delivery timeline', b: 'The 24-hour delivery window begins once Gilead Digital has received all required inputs in full. Timelines extend proportionally if inputs are submitted in parts or delayed. Add-ons such as booking or Google Business Profile verification may extend delivery; the applicable timeline is confirmed at order.' },
  { t: '3. Payment', b: 'Full payment of the configured total is due before work begins. Prices are in INR (₹) and exclude any third-party charges not listed as add-ons.' },
  { t: '4. Revisions', b: 'Two rounds of minor revisions (text edits, image swaps, colour adjustments) are included within 3 days of first delivery. Structural changes or a full redesign are treated as new scope and quoted separately.' },
  { t: '5. Content and inputs', b: 'Page content is written by Gilead Digital from inputs supplied by the client. The client is responsible for the accuracy of those inputs and for supplying rights-cleared images. Gilead Digital is not liable for copyright, trademark or factual issues arising from client-supplied material. Business email is set up on the Zoho Mail free plan; the add-on price covers setup only, and any paid Zoho plan is the client\'s choice and cost. Google Business Profile setup covers creating and optimising the profile; verification with Google must be completed by the client. Brand keyword SEO targets the first position for the client\'s exact business name and is carried out within one month; results depend on how distinctive the name is and on Google, so a specific ranking date cannot be guaranteed. Social media setup covers profile creation or completion on Facebook, Instagram, LinkedIn, X (Twitter) and Pinterest, including profile picture, cover image and business details, using material supplied or approved by the client.' },
  { t: '6. Refunds', b: 'Once development has started, payment is non-refundable. If Gilead Digital is unable to deliver due to circumstances within its control, a full refund will be issued.' },
  { t: '7. Ownership', b: 'Upon full payment and delivery, ownership of the website design and files transfers to the client. Gilead Digital retains no rights to reuse the client\'s content, logo or branding.' },
  { t: '8. Domain and hosting', b: 'One year of domain registration and hosting is included in both plans, covering standard domains at regular pricing; premium domain names are quoted separately. From the second year, renewals are billed at ₹999 per year for the domain and ₹3,999 per year for cloud hosting. Where the client supplies an existing domain, hosting only is provided.' },
  { t: '9. Support after delivery', b: 'This package covers the initial build and handover. Ongoing maintenance and updates are available separately on request.' },
];
